import { useSelector } from 'react-redux'
import { Link, Navigate } from 'react-router-dom'
import { Button, Card, Radio } from 'sfy-react'
import styles from './SelectAccount.module.scss'
import loginStyles from '../Login.module.scss'

const accountTypeDetails = {
  mobileNo: {
    linkedText: 'linkedEmails',
    confirmText: 'confirmLinkedMobile',
    replace: '@emailID',
    contactNotFound: 'mobileNotFound',
  },
  emailID: {
    linkedText: 'linkedMobile',
    confirmText: 'confirmLinkedEmail',
    replace: '@mobileNo',
    contactNotFound: 'emailNotFound',
  },
}

const SelectAccount = ({
  selectedContact,
  selectedAccount,
  selectedAccountValue,
  handleOnContactChange,
  handleOnRequestOTP,
  handleOnVerifyOTP,
}) => {
  const translatedData = useSelector((state) => state.common.translatedData)
  const selectedCountryDetails = useSelector((state) => state.common.selectedCountryDetails)
  const consumerDetails = useSelector((state) => state.user.consumerDetails)
  const loginFields = useSelector((state) => state.login.fields)

  return loginFields.consent ? (
    <Card className={loginStyles['small-cards']}>
      <form
        className={loginStyles['form']}
        onSubmit={(e) => {
          e.preventDefault()
          handleOnRequestOTP()
        }}
      >
        <h3>{translatedData.login.accountValidateTitle}</h3>
        <div className='background-primary-200 p20 mt8'>
          <p className='pb5'>
            {translatedData.login[accountTypeDetails[selectedAccount].linkedText].replace(
              accountTypeDetails[selectedAccount]['replace'],
              selectedAccountValue
            )}
          </p>
          <p dangerouslySetInnerHTML={{ __html: translatedData.login[accountTypeDetails[selectedAccount].confirmText] }} />
        </div>
        <div className={styles['radio-container']}>
          {consumerDetails.existingContact?.map((contact) => {
            return (
              <Radio
                key={contact.consumerID}
                value={contact.consumerID}
                name='contact'
                selectedValue={selectedContact.consumerID}
                classes={styles['radio-item']}
                labelClasses={`${styles['radio-label']} ${
                  selectedContact.consumerID === contact.consumerID ? styles['radio-label--active'] : ''
                } f14`}
                handleOnUpdate={handleOnContactChange}
              >
                <div className={styles['radio-text']}>
                  {selectedAccount === 'mobileNo' && <span className={styles['phone-code']}>+{selectedCountryDetails.phoneCode}</span>}
                  <span>{contact[selectedAccount]}</span>
                </div>
              </Radio>
            )
          })}
        </div>
        <Link
          className={styles['no-contact-link']}
          title={translatedData.login[accountTypeDetails[selectedAccount].contactNotFound]}
          onClick={(e) => handleOnVerifyOTP(e, 'verifyTokenAndCreateConsumer')}
        >
          {translatedData.login[accountTypeDetails[selectedAccount].contactNotFound]}
        </Link>
        <Button className={'button button-primary mt20'} isDisabled={!selectedContact} text={translatedData.common.confirm}></Button>
      </form>
    </Card>
  ) : (
    <Navigate to='/login' replace />
  )
}

export default SelectAccount
